import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Service } from '../network.service';
var $ = require('jquery');
import { AppState } from '../../../app.service';
import { NgForm } from '@angular/forms';
import { truncateString } from '../../dataprotection/dataprotection-common/common-renderers';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
import { setVcdRedirectUrlCookie } from '../../../../common/utils/utils';

@Component({
  selector: 'org-vdc-networks',
  styles: [require('../network.scss')],
  template: require('./org-vdc-networks.html'),
  providers: [
    Service, TranslateService
  ],
})

export class OrgVdcNetworks {
  private vdcsList: any;
  private isTranslationready:boolean = true;
  private subscribeHandler;
  private cardClass: string = "";
  private loaded: boolean = false;
  private rsService: RefreshSharedService;
  private refreshSubscription: Subscription;
  private currentClassName: string = '';

  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService,
              private rss: RefreshSharedService) {
      translate.use(GlobalVariables.LOCALE);
      this.rsService = rss;
      this.currentClassName = 'OrgVdcNetworks';
  }

  ngOnInit() {
    this.refreshSubscription = this.rsService.getRefreshParam()
    .subscribe (
      item => {
        this.handleEmittedValues(item);
    });
    this.rsService.setParam({
        'loadedComponent': this.currentClassName,
        'detailPageIDName': '',
        'shouldReloadInventoryTree': true
    });
    this.getVDCsList();
  }

  handleEmittedValues(item) {
     if (item.loadedComponent === this.currentClassName) {
        this.vdcsList = []
        this.getVDCsList()
    }
  }

  getVDCsList() {
      this.loaded = false;
      this.subscribeHandler = this.service.getVDCsList()
      .subscribe(
        vdcsList => {
          this.vdcsList = vdcsList;
          this.loaded = true;
        },
        error => this.service.logError(error, 'get Orgs error'),
        () => this.service.logOperationCompleted('get Orgs Completed')
      );
  }

  getTitle() {
      return (this.translate.instant('orgNetwork.organizationNetworks'));
  }

  truncateName(txt) {
    return truncateString(txt, 20, "tooltip tooltip-md tooltip-bottom-right");
  }

  ngOnDestroy() {
      this.rsService.resetParam()
      if (this.refreshSubscription) {
          this.refreshSubscription.unsubscribe();
      }
  }

  onMangeInVcd = ($event, ssoUrl: string, orgName: string) => {
      if (ssoUrl) {
          setVcdRedirectUrlCookie(orgName, ssoUrl);
          window.open(ssoUrl, '_blank');
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/network/org-vdc-networks/org-vdc-networks.ts